/**  Типы пластиковых карт. */
export enum AuthHistorySources {
  /** Веб. */
  HtmlClient = 0,

  /** Приложение */
  Mobile = 1
}
